<template>
  <div style="margin: 0 20px">
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="食材名称" prop="name">
        <el-input v-model="addEditForm.name" placeholder="请输入食材名称"></el-input>
      </el-form-item>
      <el-form-item label="食材单位" prop="unitid">
        <el-select v-fixZoom v-model="addEditForm.unitid" filterable placeholder="请选择" :clearable="true" style="width:100%;" >
          <el-option v-for="item in ingredientunits" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数量" prop="val">
        <el-input type="number" v-model="addEditForm.val" placeholder="请输入食材数量"></el-input>
      </el-form-item>
      <el-form-item label="所属餐厅" prop="restaurantid">
        <el-select v-fixZoom v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeRestaurant">
          <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" prop="vendorid">
        <el-select v-fixZoom v-model="addEditForm.vendorid" filterable placeholder="请选择" :clearable="true" style="width:100%;" >
          <el-option v-for="item in ingredientvendorsArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {addingredient, updateingredient} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditMaterial',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      ingredientunits: [], // 食材单位
      ingredientvendors: [], // 食材供应商
      ingredientvendorsArr: [],
      addEditForm: {
        id: 0,
        eid: 0,
        val: '',
        name: '',
        unitid: '',
        vendorid: '',
        restaurantid: ''
      },
      addEditRules: {
        name: [
          {required: true, message: '请输入食材名称', trigger: 'blur'}
        ],
        val: [
          {required: true, message: '请输入食材数量', trigger: 'blur'}
        ],
        unitid: [
          {required: true, message: '请选择食材单位', trigger: 'change'}
        ],
        vendorid: [
          {required: true, message: '请选择食材供应商', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ]
      }
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    this.ingredientunits = this.addEditObj.ingredientunits
    this.ingredientvendors = this.addEditObj.ingredientvendors
    if (!this.addEditObj.isAdd) {
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.eid = this.addEditObj.row.eid
      this.addEditForm.name = this.addEditObj.row.name
      this.addEditForm.restaurantid = this.addEditObj.row.restaurantid
      this.addEditForm.val = this.addEditObj.row.val
      this.addEditForm.unitid = this.addEditObj.row.unitid
      this.addEditForm.vendorid = this.addEditObj.row.vendorid
      let arr = []
      for (let i = 0; i < this.ingredientvendors.length; i++) {
        if (this.addEditForm.restaurantid === this.ingredientvendors[i].restaurantid) {
          let obj = this.ingredientvendors[i]
          arr.push(obj)
        }
      }
      this.ingredientvendorsArr = arr
    } else {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    }
  },
  methods: {
    changeRestaurant (id) {
      let arr = []
      for (let i = 0; i < this.ingredientvendors.length; i++) {
        if (id === this.ingredientvendors[i].restaurantid) {
          let obj = this.ingredientvendors[i]
          arr.push(obj)
        }
      }
      this.addEditForm.vendorid = ''
      this.ingredientvendorsArr = arr
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditObj.isAdd) {
            let data = {
              eid: this.addEditForm.eid,
              val: this.addEditForm.val,
              name: this.addEditForm.name,
              unitid: this.addEditForm.unitid,
              vendorid: this.addEditForm.vendorid,
              restaurantid: this.addEditForm.restaurantid
            }
            addingredient(data).then(res => {
              this.$notify({title: '成功', message: '成功新增食材', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              eid: this.addEditForm.eid,
              val: this.addEditForm.val,
              name: this.addEditForm.name,
              unitid: this.addEditForm.unitid,
              vendorid: this.addEditForm.vendorid,
              restaurantid: this.addEditForm.restaurantid
            }
            updateingredient(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑食材', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditMaterial.vue